export default __webpack_public_path__ + "static/media/aboutUs.eccac296.png";